import { render, staticRenderFns } from "./processList.vue?vue&type=template&id=95c334c2&scoped=true&"
import script from "./processList.vue?vue&type=script&lang=js&"
export * from "./processList.vue?vue&type=script&lang=js&"
import style0 from "./processList.vue?vue&type=style&index=0&id=95c334c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c334c2",
  null
  
)

export default component.exports